module.exports = __webpack_public_path__ + "static/media/personalized.8d96af88.svg";